module.exports = __webpack_public_path__ + "static/img/a078.2fc0efc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a078.jpg
// module id = 5Au2
// module chunks = 0